var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndicacaoP4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 95,
    viewBox: "0 0 90 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.419922 19.0201L7.93992 76.3401C8.35992 81.3001 11.4599 84.3801 16.5999 84.8401L76.0999 85.4401C81.2399 85.9001 85.7599 82.8401 86.1399 78.6201L89.5999 35.2201C89.9799 31.0001 86.0799 27.1801 80.9399 26.7201L10.4599 12.2001C5.31992 11.7401 0.799922 14.8001 0.419922 19.0201Z",
    fill: "url(#paint0_linear_20693_16763)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1399 76.1602L38.5999 80.6602L38.6199 80.6802L40.1399 76.1602Z",
    fill: "#EE8322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.78 16.4801H47.62L47.68 16.4401L47.6 13.8801L49.28 13.8401C50.6 13.7001 50.4 12.2201 50.34 11.3001C50.3 10.5801 50.26 9.86013 50.22 9.12013C50.5 9.16013 50.84 9.16013 50.96 8.92013C51.04 8.76013 51 8.58013 50.94 8.42013C50.58 7.26013 50.22 6.10013 49.72 5.00013C49.2 3.90013 48.52 2.86013 47.62 2.08013C46.88 1.44013 45.96 1.66013 45 1.84013C44.04 2.02013 43.14 2.50013 42.36 3.12013C41.84 3.54013 41.36 4.00013 41.02 4.58013C39.74 6.66013 39.94 9.30013 41.58 11.1001L39.78 16.4801Z",
    fill: "#EBB990"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.58 7.74014C48.7457 7.74014 48.88 7.60582 48.88 7.44014C48.88 7.27445 48.7457 7.14014 48.58 7.14014C48.4143 7.14014 48.28 7.27445 48.28 7.44014C48.28 7.60582 48.4143 7.74014 48.58 7.74014Z",
    fill: "#0E1010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6799 10.1202C49.7599 10.1002 49.6399 10.1202 49.6199 10.1202C49.5399 10.1202 49.4599 10.1202 49.3599 10.1002C49.0799 10.0402 48.8599 9.86017 48.7199 9.62017C48.5999 9.44017 48.3199 9.60017 48.4199 9.78017C48.6999 10.2402 49.2199 10.5202 49.7599 10.4402C49.9799 10.4002 49.8999 10.0802 49.6799 10.1202Z",
    fill: "#8B5624"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26 40.4001L44.74 62.7201L37.08 84.6401L43.54 88.1401L53.8 66.0801C54.52 64.5201 54.7 62.7401 54.26 61.0601L51.88 51.8401L36.26 40.4001Z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20693_16763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 40,
    width: 19,
    height: 49
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26 40.4001L44.74 62.7201L37.08 84.6401L43.54 88.1401L53.8 66.0801C54.52 64.5201 54.7 62.7401 54.26 61.0601L51.88 51.8401L36.26 40.4001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20693_16763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.26 40.4001L44.74 62.7201L37.44 83.8801L43.8 87.5601L53.78 66.0801C54.5 64.5201 54.68 62.7401 54.24 61.0601L51.86 51.8401",
    fill: "#00D38D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20693_16763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 40,
    width: 19,
    height: 49
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.26 40.4001L44.74 62.7201L37.08 84.6401L43.54 88.1401L53.8 66.0801C54.52 64.5201 54.7 62.7401 54.26 61.0601L51.88 51.8401L36.26 40.4001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20693_16763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1399 41.0801L54.2799 69.1601L56.0399 57.0601",
    fill: "#079D56"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2199 37.1801C36.2199 37.1801 34.9599 43.2201 39.4399 46.9201C43.9199 50.6201 43.9199 50.6201 43.9199 50.6201L55.7999 59.8001C56.8199 60.5801 57.5599 61.6801 57.8999 62.9201L64.1399 85.4001H72.2599C72.2599 85.4001 69.3999 57.6201 68.3199 56.3601C67.2399 55.1001 53.3599 35.5601 54.1599 37.1801H36.2199Z",
    fill: "#00D38D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2399 15.9C48.2599 15.98 50.1199 17.06 51.1999 18.78C51.1999 18.78 55.2799 24.12 54.7399 26.28C54.5399 27.1 53.9199 27.84 53.1199 28.04L55.0199 38.18H36.2599L34.8799 22.2C34.1199 18.76 36.8199 15.54 40.3399 15.66L46.2399 15.9Z",
    fill: "#FF5AAD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.02 19.3602C34.88 19.7602 34.8 20.1602 34.76 20.6002L35.02 19.3602ZM40.12 15.6602C39.94 15.6602 39.78 15.6602 39.62 15.6802C41.68 15.9002 43.32 17.6802 43.32 19.8002C43.32 20.0802 43.3 20.3802 43.22 20.6602L41.76 27.5802L40.72 27.5402L41.4 36.6602L42 38.0602L55.04 38.2002L54.5 35.3602L53.12 28.0602C53.94 27.8402 54.54 27.1002 54.74 26.3002C54.78 26.1802 54.78 26.0202 54.78 25.8802C54.78 23.5202 51.18 18.8002 51.18 18.8002C50.1 17.0802 48.24 16.0002 46.22 15.9202L40.34 15.6802C40.28 15.6602 40.2 15.6602 40.12 15.6602Z",
    fill: "#FF5AAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1199 85.2201L71.9199 84.8601C73.6399 87.4801 75.7599 90.5201 79.0199 91.3001C79.5399 91.4201 80.0999 91.4801 80.5999 91.7001C81.0999 91.9201 81.5599 92.3401 81.5999 92.8801C81.6599 93.4201 81.1599 94.0001 80.6399 93.8801H71.6599L69.2999 91.2801L69.0199 93.8801H66.3599L64.1199 85.2201Z",
    fill: "#ACACAC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5398 87.1801C43.3198 88.9201 44.1398 90.6401 45.6598 91.5401L46.8598 92.2601C47.6198 92.7201 47.2798 93.8801 46.3998 93.8601L39.7798 93.8001L37.8998 91.9201L37.8198 88.8801L36.6598 90.9401L35.3198 90.0401L37.4798 83.8601",
    fill: "#ACACAC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5799 13.8801H45.1799L47.6399 15.4801L47.5799 13.8801Z",
    fill: "#D98651"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3999 11.6001L70.8599 15.4801L65.1399 9.36008C63.9399 8.08008 61.8799 8.06008 60.9999 9.32008L59.3999 11.6001Z",
    fill: "url(#paint1_linear_20693_16763)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2398 18.44L68.8198 14.46L76.6798 13C78.3198 12.7 80.0198 13.96 80.0998 15.56L80.2398 18.44Z",
    fill: "url(#paint2_linear_20693_16763)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9399 15.0802L68.8799 14.5602C68.1599 14.3802 67.7199 13.6402 67.8999 12.9202C68.0799 12.2002 68.8199 11.7602 69.5399 11.9402L71.5999 12.4602C72.3199 12.6402 72.7599 13.3802 72.5799 14.1002C72.3999 14.8402 71.6599 15.2802 70.9399 15.0802Z",
    fill: "url(#paint3_linear_20693_16763)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6798 45.1002L49.6798 38.2402C47.7198 37.6602 46.5998 35.5802 47.1798 33.6202L53.2398 13.2802C53.8198 11.3202 55.8998 10.2002 57.8598 10.7802L80.8598 17.6402C82.8198 18.2202 83.9398 20.3002 83.3598 22.2602L77.2998 42.6002C76.7198 44.5602 74.6398 45.6802 72.6798 45.1002Z",
    fill: "url(#paint4_linear_20693_16763)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0199 42.3601L59.6199 41.0601L67.7999 13.5801L72.1999 14.9001L64.0199 42.3601Z",
    fill: "url(#paint5_linear_20693_16763)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5398 29.96L80.2198 34.36L49.3398 25.16L50.6598 20.74L81.5398 29.96Z",
    fill: "url(#paint6_linear_20693_16763)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3799 21.5601C19.9599 20.2201 20.0599 18.7201 20.8199 17.5801C21.5399 16.5201 22.7599 15.5201 23.9599 15.1001C25.2399 14.6601 26.6599 14.6001 27.7799 13.7801C28.9799 12.9201 29.5199 11.4201 30.4599 10.2601C31.1599 9.40008 32.0999 8.74008 33.1599 8.36008C34.7799 7.78008 36.6999 7.88008 38.0599 6.82008C39.2199 5.92008 39.6799 4.40008 40.5999 3.24008C41.5199 2.04008 42.7199 1.36008 44.1799 1.02008C45.4399 0.740085 47.1199 1.14008 48.1199 1.98008C49.2799 2.96008 48.0599 4.22008 47.0999 4.68008C46.2999 5.06008 45.4199 5.18008 44.5399 5.30008L44.7399 8.64008C44.1999 8.20008 43.3599 7.88008 42.7399 8.24008C42.3999 8.44008 42.1799 8.82008 42.0799 9.20008C41.8399 10.2001 42.3999 11.3201 43.3199 11.7401C43.3999 12.9001 42.7599 14.1601 41.8199 14.8401C41.3799 15.1601 40.8799 15.3801 40.4799 15.7401C39.9599 16.2201 39.6799 16.8801 39.2199 17.4001C37.1999 19.7001 33.1399 18.9001 31.1199 21.3201C30.6799 21.8601 30.3999 22.5001 29.9999 23.0801C29.0199 24.4801 27.3199 25.3201 25.6199 25.3201C23.9199 25.3001 22.2399 24.4401 21.2199 23.0801C20.8399 22.6601 20.5599 22.1201 20.3799 21.5601Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 81.8201C13.1 81.8201 12.08 83.16 12.48 84.52L15.16 93.8L26.14 94.06L29.28 84.9C29.74 83.56 28.76 82.14 27.34 82.12L22.12 82L20.72 81.96L19.84 81.9401L18.44 81.9L14.56 81.8C14.54 81.82 14.52 81.8201 14.5 81.8201Z",
    fill: "#8C55A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48 70.1C36.38 68.62 35.38 67.2 34 66.66C33.5 66.46 32.98 66.38 32.46 66.38C30.72 66.38 29 67.38 27.9 68.68C24.52 72.7 22.26 77.52 20.32 82.4C20.48 81.26 20.76 80.16 21.16 79.08C21.46 78.24 21.84 77.4 21.98 76.5C22.1 75.7 22.04 74.86 22.26 74.08C22.64 72.72 23.8 71.78 24.32 70.46C25 68.78 24.54 66.8 25 65.04C25.38 63.62 26.34 62.44 26.8 61.06C27.02 60.44 27.12 59.76 27.12 59.1C27.12 57.82 26.74 56.54 26.02 55.54C25.04 54.16 22.78 53.28 21.04 53.28C21.04 53.28 21.04 53.28 21.02 53.28C21 53.28 20.98 53.28 20.96 53.28C20.62 53.28 20.26 53.28 19.92 53.26C19.84 53.26 19.76 53.26 19.68 53.26C19.18 53.26 18.66 53.34 18.14 53.46C16.98 53.76 15.88 54.4 15.18 55.28C14.34 56.34 13.9 57.72 13.9 59.1C13.9 59.66 13.98 60.22 14.14 60.76C14.38 61.56 14.76 62.32 15.12 63.06C15.38 63.62 15.62 64.2 15.76 64.82C15.88 65.38 15.9 65.94 15.9 66.5C15.9 67.02 15.88 67.54 15.88 68.04C15.88 68.8 15.92 69.56 16.18 70.26C16.64 71.58 17.76 72.58 18.08 73.96C18.26 74.74 18.14 75.58 18.24 76.38C18.34 77.28 18.68 78.14 18.94 79C19.28 80.08 19.5 81.22 19.62 82.34C18 77.64 16.1 73 13.22 68.98C13.06 68.74 12.88 68.52 12.7 68.28C11.64 66.88 9.86004 65.76 8.04004 65.76C7.60004 65.76 7.14004 65.82 6.70004 65.98C5.28004 66.46 4.24004 67.82 4.06004 69.3C4.04004 69.46 4.04004 69.62 4.04004 69.76C4.04004 71.08 4.68004 72.4 5.74004 73.24C6.84004 74.1 8.30004 74.42 9.60004 74.94C10.34 75.24 11.02 75.58 11.6 76.14C12.38 76.9 12.84 77.98 13.7 78.66C14.3 79.16 15.06 79.42 15.76 79.78C16.92 80.4 17.88 81.32 18.56 82.44L19.62 82.46L20.3 82.48L21.36 82.5C22.08 81.42 23.1 80.52 24.28 79.98C24.98 79.64 25.76 79.42 26.38 78.96C27.26 78.32 27.78 77.26 28.6 76.54C30.24 75.1 32.8 75.2 34.6 73.92C35.74 73.12 36.46 71.74 36.46 70.34C36.5 70.28 36.5 70.18 36.48 70.1Z",
    fill: "url(#paint7_linear_20693_16763)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 28.7002,
    width: 27,
    height: 19.4,
    fill: "url(#pattern0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5198 43.8799L44.9798 41.7999C43.1998 41.4999 41.7598 40.1999 41.2998 38.4599L36.0598 18.7799L42.1598 17.1599L47.1798 35.9999L58.4798 39.5999L57.5198 43.8799Z",
    fill: "#EBB990"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8798 16.68C37.6398 16.8 37.4198 16.94 37.1998 17.12C35.8398 18.18 35.2798 19.96 35.7798 21.6L38.0198 29.6L45.5998 26.12L43.7398 19.3C43.6598 19.02 43.5598 18.74 43.4198 18.48C42.4598 16.6 40.1998 15.76 38.2598 16.5C38.1398 16.54 38.0198 16.6 37.8798 16.68Z",
    fill: "url(#paint8_linear_20693_16763)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4997 39.7401C58.3997 39.3201 60.3997 38.7801 61.4197 38.5801C61.7397 38.5201 62.0597 38.4601 62.3597 38.3801C62.5397 38.3401 62.8797 38.1401 63.0797 38.2001C63.8397 38.3801 62.8397 39.1001 62.5997 39.3001C62.1997 39.6201 61.4197 40.2201 62.0397 40.7001C62.7597 41.2601 63.6797 41.0801 64.4997 40.9401C65.0997 40.8401 66.7797 40.5601 66.9997 41.4201C67.1197 41.9401 66.4197 42.7601 66.1197 43.1201C64.3197 45.4401 61.2597 45.0401 58.7397 44.4201C58.1797 44.2801 57.2797 43.5401 56.7397 43.3601",
    fill: "#EBB990"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20693_16763",
    transform: "scale(0.00740741 0.0103093)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20693_16763",
    x1: 10.1583,
    y1: 81.9333,
    x2: 74.9318,
    y2: 17.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0739316,
    stopColor: "#EC8709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2075,
    stopColor: "#EF9910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3662,
    stopColor: "#F2A616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    stopColor: "#F4AE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20693_16763",
    x1: 59.9663,
    y1: 9.68603,
    x2: 71.5127,
    y2: 13.2675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20693_16763",
    x1: 80.9265,
    y1: 16.3657,
    x2: 69.4149,
    y2: 12.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20693_16763",
    x1: 70.9055,
    y1: 11.2023,
    x2: 70.158,
    y2: 13.8356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#EA7E05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    stopColor: "#ED8C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8584,
    stopColor: "#F1A315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20693_16763",
    x1: 49.7564,
    y1: 20.8288,
    x2: 80.8063,
    y2: 35.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20693_16763",
    x1: 62.0356,
    y1: 26.2024,
    x2: 69.7953,
    y2: 29.7541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20693_16763",
    x1: 63.5797,
    y1: 31.3974,
    x2: 67.0193,
    y2: 23.5688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20693_16763",
    x1: 4.47723,
    y1: 83.766,
    x2: 41.668,
    y2: 51.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1631,
    stopColor: "#00CA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#00B375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#008D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006B3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_20693_16763",
    x1: 44.2696,
    y1: 20.0448,
    x2: 35.4748,
    y2: 24.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795175,
    stopColor: "#B60B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#CE156E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3018,
    stopColor: "#E01E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4416,
    stopColor: "#ED2479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6232,
    stopColor: "#F5277B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7287C"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_20693_16763",
    width: 135,
    height: 97,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAABhCAYAAAD8+rKVAAAACXBIWXMAAAsSAAALEgHS3X78AAANn0lEQVR4nO3bW3IcR3oF4HPOn1XVjfutMWOF7FCMFX5h6MULcNCL0Ba8Ar+bG/AGZgvaBN/8pAc7gnLEmCNR4kUiQYAA+lLXzN8P3U1CFDWesTSBlphfRKOqG9VAVeXBn5nVBSDLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsizLsuy9x9vegbfwR9Zv8h9Zz35mmxQOAtCN5Xr9JgeQVsubj7e3edd69hfalHCsw2AACgBh9TBgS1sACDoAFxQNNgSEaLBkMBfkABAQ/BG2E/Agh+dnsAnhWFeKAKACMAYwAspxCZSOUBRF0GrTWFG90Tqj9UYbCCZRSZDXVAoqYmndMAtVNKuSWeFS6XgCBFS+jbM0wsh3sesTTPwz3FkF5N56f3J4VjYlHAFACWALwC5Q7AXYnkE7Mo0BlTKjAUlQR7IVrS0Ce7GMAJNYRjENSaEvBrSFyn5QOYghmbokyE0hVfU4RsOwHfo4te1UWOWlRg48QRUqP3s0SSMc+i7+4BNM/M4qPPfw+ut7E55NCMe6OxkB2AZwEBCODXZM4yEV9uXcpqwURMkGkp3BumChJywaGWkWSessoaWKOohNYuhFxZJKokVXGIrIXiG0jNZXhqFnkYKKJAXvNKRx6xGlDf0sxW3bT5Vd+kgjfwKgCts+2Z6nLx/8MDzA6wD9asKzCeFYV44KN8Ih6FQWJiBPTDoktWNuFWUSlEyWJCUhJEnJZJGwTmRjsIVojWidLAykIsFoCh1drYy1eWiC2CdZFC1ZDBHiwGR9KNRaLHqEMBSKqbAqteq8akbJC0XrtoZUXcemOkpVce2jctvxGNgOr3y+/VE6HD3zP3z+gU/w4Hvh+TH3AAD/5qvm2JhAbUo4hGW3MsKyWzkMsBMZJyY7NWoi2pGofdC2BJVGBdHMaEYaTOaSBkKNaI1RLRk6k6JgkdIgqDOqkWwhqDGGTrRBVCQV5epkoSWtDrBG8t5VRFNKIRaRZkNy9BWKNpXolcqhtJSijVNQ57H1hC7Eamt3UL2IfTVJ42L+zsbeLvdevz4chNS+qNKr3x2mO5994feW1efWQ7IJ4QC+P1MZA9gByv0AHRUWTkw2ETkR7YS0Q0n7ou0K2jLaiLJCNDPJBQ2iejEMkgbSUkCIkiLJfhkcq0W1YuhIRmOIggbKOoENYQuZNcHZUTaIFkWLAjtCrVG1iqJxoA9SdFoqkqJCGBzqw6AWHvpQYkgBKSi8bugxtl4fdK/Cx51SM4rRLPbhYui/jvP+zgMMmxCQTQkHVw/Dmy5mC6h2Cth+GcKRyU5Em5A2MemE0LFkR6LtidwxhhGpQhJFwRhckIvmktxoaR0Ao3WkelGDGJKkaLAIqjeGRmRtVGsKHcEohijaQKAj1RiLBYlGCl2QBtCiOSOgTmRLhTp4aBDUMymK8oDVkS2/QDQPKpKDAxLaymxe9928Cu3iq8u6XQUk3U5zLIXb/OU33LwmkQBEAD3QNj3GCw4+tUKXibwQ/BzupxIndD8lcQLwyIE9AjsARnQUgJsTAiGAqx/ORCA5fCARCSYAvlomEgOJjmTnYO/uA8nk8Ah4BNmTbACvQWtJdA5EAdGBQWJHqiF8AcWGjs5MAwFPACwJMEIQRDmIQe6tiVOHXwSNX7YDcDg6iA8+PYz4DMQtVo9NCcfazSugCcAA1F2HvYX1PgtlulIKryicu/yMsJcATgFM6H4C4pDOPZDbIMYkSjgK0IMDApeVkqDD4U4HAYe7u+ByJIdHp0fCoxMRoBNIgCdQA8iO8A7wHo7BiQRHBBEB7x1ojKxBtgQ7OCIE5+o63+qCDSgkIPWUzeF+DvpThc4LWjsa0ODLV/3qHNyaTQsH8M4qct3XmHS7XVMDPktldRUSLkC8TAkvJJxCmBCYOPwI9AMHduG+A2LLl9WkAj0AMIcbAQJc1RQA7nDBBU9wdxBOh0NwJxykw5FIjw5GARH0uHpnWlWfgUDnQAewBzE4PQHu4vqQCBKOhESyg6erKD0TfQB4LfBC1ocP5i+53v62bGI41t4KyVmcAv0Ek7bpVPsY02rAVTK/kOEMzhOQJwCPARwROAR5CPoBgT0SOwDHcFTgstsBIAfk8NUk0uF007JaLHfCl9lwOCi4A2nZau4O+PIlOEB3rLsgRCBFB+NqW/jqUJZPHE6PgNekxnS0IF94QiWl0G21nF0c8XajsdnhWPteSM5wFgH0k3rSCqg1xjQ5LkE7N/fnrnTIZIcQjwAeO3AC4hiOI9D3QewCWIXECziCk/LX7UD6qmgsQ+OrffBleOAGYbm5A044uS5ydEAJ8GXm1m/CzSLgq+0wYHn+F4AX7qAIR2Qqm5HvVi/9tmcLv4RwrL0jJB/3k/qqrfa4QF9O+4KvLPEM4G4iD0Q/AjmBYwL56bK64Mgd+yB3HRyDqAgv4B6cyyqCH/7BvmlWAOvwcJUZAO5cv8nNQV8PgX2dOq4Pgk4uXyZhCQmEBjo7d3QD0aeuj+ejv/HbrRu/rHCs3QjJw3QGRFzf6X6Dl+24Gs/Z71wPxTCypHMEncHxwqkTJJxCOHWsZzg4IrAP910QY5DLkCzPid78ua9Gr8CN8QluNPayT3mrGd+EiQ7//ujBHUgi3N2jwJbwhXtcJKJOQ+qut7v4ZXF16xfB7LZ34Cdatc2ZzzGPl83fDwf9VTfbsc67WBu3FyXiwkxzd5uZMJPbnORiOSVVJ7EnFUn68iEnBRIUhOU6QYqrJUgCN9bfLPn6OW4+B1fvWW4nIgHsRUwJnjnxVM5vnPy2kF10zXX9yX+gv4/7txqQX2LleNuNK4mfp0dAxMu7w8d40l1NZm1otuvSMXXGqyi7cKaXgfbCxVPSTx08BXBC4AiO/eXA1bcAlQkouJzZCMuB62o88qdvU7vZ5Syrx5vvrkYwyemDO1sgLQjNQMxB1DW9r66OInDx1ztjf6ZfeuV4Fwce+QUu0mJxJx50zwftpD62RWsY1RZ84eQ8wGaiZnDNCS1INiI7UD2oXkAUGUklkr6uFAL/70qCN9Xi7Uoi0CEOAmuQr0h+C+Ax3Z8Y8MJn6boZj7t///Zfb/UaB/DrqBzvsqom9/0hkHB2N36MJ71NttpOTb2PrWkf/arweBHIlyRe0HHq4ITEhPAjBw8A7ALccceWiDGXHw4WDgQ45HyrkviqgN0Yj/Dm7iwHrk735GRPR52Q5oBmYFoMUe2mjDeAX2fleNvrSnJn8VG8nD4f0mivHwW2RFl7GhYE5yZNIc1IzESbgZqRWhBsSPYEB5KJkIv0ZWUQdbNOvHM8wtdVAxREJEItyamAMwJPCXyTZM8iu1fe1Bsx3gB+vZXjbQ7AVyc83T37MD7B1301+bDdLq12YJp6XAbh3Ap/7sShkh9SPJJ4DOCE5DGBIxD7jvW1Eq9AFM71DMf5Zuby9oeqdLq7k5Hw3h1NIucEpu4+Q4+aXeyr6WaMN4D3o3K8zR/dqCTPp6Mhjeq+KtgksGYq5gE+FXUt4ZrAFLI5wQWhBmCnZSWJIp2SC1zNcJYjDpDQ6vmqijhBp5gI9iRngM4FPHX4Nw49jimdhVhON2W8Abyf4VhbheRhurP4KL66PuqH8aLfqkJDxTphNJcwBzAzagpwJmoOavlx/fJe1h54Mw0W6JTW3Q1JvumCxASoB7ggeAn6c4CPCftaPjyLSeexvV6c/+ff9V/gs1vvUoD3Oxxr/giP/Axf+D/N/zE+v/x6KA4+6rrqqtMi1aEoFwQXcs1pPhM4AzQ3ckGxEdiR6klGYhUSajm7WV0NJRRBdnQuSF4ReAHnYzq+VsI3g+w7dcXl/Lpu/uHyLG7CeAO47euzm4kAeBd3Nf54bPXVTmHlUJXjrbE43q0C9gk7ouxE1CnBU8lORZ4sb2W0fZI7hMaiFSIp2kCqIXlN6KXAJwT/CNf/uPDHgPg0+vZFO1T17z//l2H12cuty5Xj3fwRHvnDi4fpo8VpHP2GQ31lfUpqR7La3Reg5jLO6JxBmgu2ANkQbLm8I6wj1VJcALwmeEHwWxKPAXwF6CtAjzEML5pUXtZnB/Xf/veT4T7+eSOCAeTK8ee4UUk+sfoqFofHs4rD/thHcbeU7ZvzCAwnxjAReUrqWNQBgC3RJKkjeA3YmRHfwu2pDE8T9Lzz6qKt+9nj/5q393EvYgNuLF57X6ayP8WbafDDu+ku7sdm/5O+rmJ7OLDuS0zhugrERUo8o/CcSMcu7QvccrjBvXNiakwvPfEFLL7ovTyn8aqd9fNxsdfdx3x9B9zGyJXjL0fgHu/ivsYff2I7VSyGyGqr1Dh5uVPI9iDtFQo7iT5mMskwkJoH6CpGXALpKpaYWYcGeNb//vMPIm75ZuJ3yeH4//tBSICqtLIYVSrHGDgKBUomiGbR49CGFGokLLrdcb39fNx99/C3w2f4NG3KAPRtORw/3euQTO7cVTNC2AsI5m3hTW/VuGTsPGlURde4T0Xdl9Nn8YPPP4ib8L8pf0oOx8+HwD1+igc8u3uHkzPot+05px8ec/fJuX9XHfvZBOnufaRND8VaDsdfx+q83uM9/OAfrDc+FFmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZVmWZdlr/wugfQ7SoZfbIgAAAABJRU5ErkJggg=="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndicacaoP4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indicacao_p4.8a4a9237dadf60a7f7f14f42503605bd.svg";